module.exports = __webpack_public_path__ + "h5/img/bluelocation.3fa5da1c.png";